import { DependencyList, useCallback, useEffect, useRef } from "react";
import { STICKY_TOP, STUCK_OVERSHOOT } from "../common/components/StickyBar";

// Returns a ref for a 1px anchor to render immediately above a sticky bar, and
// the scroll that parks the bar at the top of the viewport.
export function useListTopScroll(enabled: boolean, deps: DependencyList) {
  const anchor = useRef<HTMLDivElement>(null);
  const previous = useRef<unknown[] | null>(null);

  const scrollToList = useCallback((force = false) => {
    const el = anchor.current;
    if (!el) return;

    const top =
      el.getBoundingClientRect().top +
      window.scrollY -
      STICKY_TOP +
      STUCK_OVERSHOOT;

    // Skips the scroll when already above the list, and stops a slider drag
    // re-firing on every frame once the target has been reached.
    if (force || window.scrollY > top)
      window.scrollTo({ top, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const current = [enabled, ...deps];
    const prev = previous.current;
    const changed =
      !prev ||
      prev.length !== current.length ||
      current.some((value, i) => !Object.is(value, prev[i]));

    previous.current = current;

    if (!changed || !enabled) return;
    scrollToList();
  });

  return { anchor, scrollToList };
}
